import { useEffect, useState } from 'react'

import { MINIMUM_YEAR_THAT_CAN_BE_ENTERED } from "../config/defaultValues";


export default function useDateValidation(departedData, setDepartedData) {
  const [datesIsChange, setDatesIsChange] = useState(false);
  const [bornBeforeDeath, setBornBeforeDeath] = useState(false);
  const [bornBeforeDeathTestStarted, setBornBeforeDeathTestStarted] = useState(false);
  const [bornYearTest, setBornYearTest] = useState(false);
  const [deathYearTest, setDeathYearTest] = useState(false);
  const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const dateNow = new Date();
  dateNow.setMilliseconds(dateNow.getMilliseconds() + 5000);
  const nowYear = parseInt(dateNow.toISOString().slice(0, 4));
  const nowMonth = parseInt(dateNow.toISOString().slice(5, 7));
  const nowDay = parseInt(dateNow.toISOString().slice(8, 10));
  let maxMonth = 12;
  let maxDay = 31;

  useEffect(() => {
    bornDateTest();
    deathDateTest();
    setBornBeforeDeathTestStarted(true);
    setTimeout(() => {
      if (!bornBeforeDeathTestStarted) setBornBeforeDeath(prevState => !prevState)
    }, 2000);
  }, [datesIsChange]);

  useEffect(() => {
    bornBeforeDeathTest();
  }, [bornBeforeDeath]);

  const bornBeforeDeathTest = () => {
    if (departedData?.bornYear && departedData?.deathYear && departedData?.bornYear >= departedData?.deathYear) {
      setDepartedData({
        ...departedData,
        bornYear: departedData?.deathYear
      });
      if (departedData?.bornMonth && departedData?.deathMonth && departedData?.bornMonth >= departedData?.deathMonth) {
        setDepartedData({
          ...departedData,
          bornMonth: departedData?.deathMonth,
          bornYear: departedData?.deathYear
        });
        if (departedData?.bornDay && departedData?.deathDay && departedData?.bornDay > departedData?.deathDay)
          setDepartedData({
            ...departedData,
            bornDay: departedData?.deathDay,
            bornMonth: departedData?.deathMonth,
            bornYear: departedData?.deathYear
          });
      }
    }
    setBornBeforeDeathTestStarted(false);
  }

  const bornDateTest = () => {
    const testedYear = departedData?.bornYear;
    let testedMonth = departedData?.bornMonth;
    const testedDay = departedData?.bornDay;
    const dateType = "born";

    if (testedYear && testedYear > nowYear)
      setDepartedData({
        ...departedData,
        [dateType + "Year"]: nowYear
      });
    else setTimeout(() => {
      if (testedYear && testedYear < MINIMUM_YEAR_THAT_CAN_BE_ENTERED) setBornYearTest(prevState => !prevState);
    }, 5000);

    testDate(testedYear, testedMonth, testedDay, dateType);
  }

  const deathDateTest = () => {
    const testedYear = departedData?.deathYear;
    const testedMonth = departedData?.deathMonth;
    const testedDay = departedData?.deathDay;
    const dateType = "death";

    if (testedYear && testedYear > nowYear)
      setDepartedData({
        ...departedData,
        [dateType + "Year"]: nowYear
      });
    else setTimeout(() => {
      if (testedYear && testedYear < MINIMUM_YEAR_THAT_CAN_BE_ENTERED) setDeathYearTest(prevState => !prevState);
    }, 5000);

    testDate(testedYear, testedMonth, testedDay, dateType);
  }

  const testDate = (testedYear, testedMonth, testedDay, dateType) => {
    maxMonth = 12;
    maxDay = 31;

    if (testedMonth && testedMonth < 1)
      setDepartedData({
        ...departedData,
        [dateType + "Month"]: 1
      });
    else {
      if (testedYear && testedYear === nowYear) {
        maxMonth = nowMonth;
      }
      if (testedMonth && testedMonth > maxMonth)
        setDepartedData({
          ...departedData,
          [dateType + "Month"]: maxMonth
        });
    }

    if (testedDay && testedDay < 1)
      setDepartedData({
        ...departedData,
        [dateType + "Day"]: 1
      });
    else {
      daysInMonth[1] = 28;
      if (isLeapYear(testedYear)) {
        daysInMonth[1] = 29;
      }
      maxDay = daysInMonth[testedMonth - 1];
      if (testedYear && testedYear === nowYear && testedMonth && testedMonth === nowMonth) maxDay = nowDay;
      if (testedDay && testedDay > maxDay)
        setDepartedData({
          ...departedData,
          [dateType + "Day"]: maxDay
        });
    }
  }

  const isLeapYear = (year) => {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  useEffect(() => {
    if (departedData?.bornYear && departedData?.bornYear < MINIMUM_YEAR_THAT_CAN_BE_ENTERED)
      setDepartedData({
        ...departedData,
        bornYear: MINIMUM_YEAR_THAT_CAN_BE_ENTERED
      });
    setTimeout(() => {
      if (!bornBeforeDeathTestStarted) setBornBeforeDeath(prevState => !prevState)
      testDate(departedData?.deathYear, departedData?.deathMonth, departedData?.deathDay, "born")
    }, 200);
  }, [bornYearTest]);

  useEffect(() => {
    if (departedData?.deathYear && departedData?.deathYear < MINIMUM_YEAR_THAT_CAN_BE_ENTERED)
      setDepartedData({
        ...departedData,
        deathYear: MINIMUM_YEAR_THAT_CAN_BE_ENTERED
      });
    setTimeout(() => {
      if (!bornBeforeDeathTestStarted) setBornBeforeDeath(prevState => !prevState)
      testDate(departedData?.deathYear, departedData?.deathMonth, departedData?.deathDay, "death")
    }, 200);
  }, [deathYearTest]);

  return { setDatesIsChange }
}